import { render, staticRenderFns } from "./Airport.vue?vue&type=template&id=84ee759e"
import script from "./Airport.vue?vue&type=script&lang=js"
export * from "./Airport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports